import contractReducer from 'entities/insurance-contract/main-info/index';
import specialPogramReducer from 'entities/insurance-contract/special-pogram/index';
import paymentSheduleReducer from 'entities/insurance-contract/payment-shedule';
import { contractsListReducer } from 'entities/insurance-contscts';
import programsListReducer from 'entities/insurance-programs';
import { insuredPersonCaseReducer } from 'entities/insured-person-case';
import insuredPersonsListReducer from 'entities/insured-persons';
import programReducer from 'entities/program-case';
import taskCaseReducer from 'entities/task/index';
import DirectoryReducer from 'entities/directory';
import CreateTaskReducer from 'entities/create-task';
import tasksListReducer from 'entities/tasks';
import checkSessionReduser from 'entities/protected-route';
import GuaranteeLettersReduser from 'entities/guarantee-letter';
import EditTaskReducer from 'entities/edit-task/index';
import AppDrawerReducer from 'entities/app-drawer/index';
import projetcsReducer from 'entities/projects/index';
import statisticsReducer from 'entities/statistics/index';
import TaskNewReducer from 'entities/task-new/index';
import { combineReducers } from 'redux';
import UnreadMessagesPresenceReducer from 'entities/unread-messages/index';


const rootReducer = combineReducers({
    insuranceContractsList: contractsListReducer,
    insuranceProgramsList: programsListReducer,
    programCase: programReducer,
    contractCase: contractReducer,
    specialPogramCase: specialPogramReducer,
    contractPaymentShedule: paymentSheduleReducer,
    insuredPersons: insuredPersonsListReducer,
    policyCase: insuredPersonCaseReducer,
    tasksList: tasksListReducer,
    taskCase: taskCaseReducer,
    directory: DirectoryReducer,
    createTask: CreateTaskReducer,
    checkSession: checkSessionReduser,
    guaranteeLetters: GuaranteeLettersReduser,
    editTask: EditTaskReducer,
    appDrawer: AppDrawerReducer,
    projetcs: projetcsReducer,
    statistics: statisticsReducer,
    taskNew: TaskNewReducer,
    unreadMessagesPresence: UnreadMessagesPresenceReducer,
});

export default rootReducer;